import React from 'react';

// Isolates every Document AI Summary UI element: if anything inside throws,
// it renders nothing instead of taking down the Documents tab around it.
class DocAiSummaryBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error('[DocAiSummary] UI error suppressed:', error);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default DocAiSummaryBoundary;
